import React from "react";
import "./Contact.css";

/* Multi idioma */

const socialLinks = [
  {
    href: "mailto:zaid.rjab1@gmail.com",
    iconClass: "fas fab fa-envelope",
    label: "Gmail",
  },
  {
    href: "https://www.linkedin.com/in/zaid-rajab/",
    iconClass: "fab fa-linkedin-in",
    label: "Linkedin",
  },
  {
    href: "https://api.whatsapp.com/send?phone=962782561613",
    iconClass: "fab fa-whatsapp",
    label: "Whatsapp",
  }
];

const Contact = () => (
  <section className="contactos" id="contact">
    <h2 className="heading">
      Let's Connect
    </h2>

    <div className="icons">
      {socialLinks.map((link, index) => (
        <a
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          data-aos="zoom-in"
          key={index}
        >
          <div className="layer">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span className={link.iconClass}></span>
          </div>
          <div className="text">{link.label}</div>
        </a>
      ))}
    </div>
  </section>
);

export default React.memo(Contact);
